export var DATA_LAYER_READY_EVENT = 'e_dataLayerReady';
export var PAGE_TYPE = 'pageType';
/* https://developers.google.com/tag-platform/tag-manager/datalayer#get
    window.dataLayer.push(function () {
    const event = this.get('event');
    console.log(event);
  });
*/
/**
 * Get gtm ready status based on dataLayer ready event
 *
 * @return {*}  {boolean}
 */
export var getIsGtmReady = function () {
    if (!window || !('dataLayer' in window) || !Array.isArray(window.dataLayer))
        return false;
    var isDataLayerReadyEventPresent = false;
    window.dataLayer.push(function () {
        var pageType = this.get(PAGE_TYPE);
        isDataLayerReadyEventPresent = !!pageType;
    });
    return isDataLayerReadyEventPresent;
};
